import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default ({onCancel, onConfirm, ...props}) => (
  <Dialog
    title="Löschen"
    modal
    {...props}
    actions={[
      <FlatButton label="Abbrechen" onTouchTap={onCancel} />,
      <FlatButton label="Ja" primary onTouchTap={onConfirm} />
    ]}
  >
    Der Eintrag wird gelöscht. Sind sie sich da wirklich sicher?
  </Dialog>
);



// WEBPACK FOOTER //
// ./src/components/DeleteModal.js